import debounce from 'lodash.debounce'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router'
import { setFavorite, unsetFavorite } from '@/redux/actions/favorites'
import { IRootState } from '@/redux/types'
import useGeneralSummaryReport from '../../../../shared/hooks/useGeneralSummaryReport'
import { isStandalone } from '@/contexts/shared/utils/IsStandAlone'

function useResourceActions(filters: any, setFilters: any) {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const { resourcecategories: categories } = useSelector((state: IRootState) => state.resourcecategory)
  const { resourcetypes } = useSelector((state: IRootState) => state.resourcetype)

  const { handleClickGeneralSummaryReport } = useGeneralSummaryReport(2)

  const [display, setDisplay] = useState<number>(1)

  const handleFavorite = (resource_id: number) => (state: boolean) => {
    handleClickGeneralSummaryReport(resource_id)
    if (state) {
      dispatch(
        setFavorite({
          id: resource_id,
          state,
          type: 'resource'
        })
      )
    } else {
      dispatch(
        unsetFavorite({
          id: resource_id,
          state,
          type: 'resource'
        })
      )
    }
  }

  const handleDownload = (resource_id: number, alias: string, ext: string) => {
    const URL = `${import.meta.env.VITE_API_URL}/resources/download/`

    if (isStandalone()) {
      console.log('download in standalone')
      const link = document.createElement('a')
      link.href = URL + resource_id
      link.download = `${alias ?? ''}.${ext ?? ''}` || 'resource'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    } else {
      console.log('download in browser')
      window.open(URL + resource_id)
    }
  }

  // const handleDownload = (resource_id: number) => {
  //   handleClickGeneralSummaryReport(resource_id)
  //   const URL = `${import.meta.env.VITE_API_URL}/resources/download/`
  //   window.open(URL + resource_id)
  // }

  //Multiple Download Resources
  const handleAllResourcesDownload = async (selectedCards: number[]) => {
    if (selectedCards?.length === 0) return

    const URL = `${import.meta.env.VITE_API_URL}/resources/downloads/${selectedCards.join(',')}`
    window.open(URL, '_blank')
  }

  const changeDisplay = (mode: number) => {
    setDisplay(mode)
  }

  const handleSearch = debounce((event: any) => {
    const value = event.target.value
    if (value !== '' && value !== null) {
      const rawValue = value
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
      setFilters({ ...filters, searchText: rawValue })
    } else setFilters({ ...filters, searchText: '' })
  }, 500)

  const handleClickMediaFileBlock = (id: number, hasAccess: boolean) => {
    if (hasAccess) navigate(`/biblioteca/${id}`)
  }

  const getSubsection = () => {
    let subsection = null
    if (filters.resourcetype_id !== null && filters.category_id === null && resourcetypes.length > 0)
      subsection = resourcetypes.find((resourcetype: any) => resourcetype.id === filters.resourcetype_id).name
    else if (filters.resourcetype_id !== null && filters.category_id !== null && categories.length > 0) {
      const objCategories = categories.find((category: any) => category.id === filters.category_id)
      if (subsection) subsection = objCategories.name
    }

    return subsection
  }

  return {
    display,
    handleDownload,
    changeDisplay,
    handleSearch,
    handleFavorite,
    handleClickMediaFileBlock,
    getSubsection,
    handleAllResourcesDownload
  }
}

export default useResourceActions
